<template>
  <!-- ロード画面 -->
  <div v-if="isLoading">
    <span class="mdi mdi-spin mdi-loading"></span>
  </div>
  <!-- data -->
  <div v-else>
    <ModalQuestionnaireData
      :isShowModal = "isQuestionnaireData"
      :questionnaireData = "questionnaireData"
      :isQDLoading = "isQDLoading"
      @cancel = "cancelQuestionnaireData"/>

    <div class="record" v-for="(c, idx) in colTitleList" :key="idx + '-record'">
      <p class="left-col">{{c}}</p>
      <template v-if="(idx === 1 || idx === 5) && !isInitLoading">
        <p class="right-col">{{getRecordData(c)}}</p>
      </template>
      <template v-else-if="(idx === 1 || idx === 5) && isInitLoading">
        <p class="right-col"><span class="mdi mdi-loading mdi-spin"></span></p>
      </template>
      <template v-else-if="idx === 6">
        <p class="right-col">{{getRecordData(c)}}
          <button class="button is-small" @click="dispQuestionnaireData()">
            詳細
          </button>
        </p>
      </template>
      <template v-else>
        <p class="right-col">{{getRecordData(c)}}</p>
      </template>
    </div>
  </div>
</template>

<script>
import ModalQuestionnaireData      from '@/components/ChatBot/organisms/ModalQuestionnaireData'

export default {
  components: {
    ModalQuestionnaireData
  },

  props: {
    chatbot: {
      type: Object,
      required: true,
    },
    userChatBotBookMark: {
      type: Array,
      required: true
    },
    sitemapRootList: {
      type: Array,
      required: true
    },
    sitemapEmploymentList: {
      type: Array,
      required: true
    },
  },
  data () {
    const colTitleList = [
      '作成日',
      'ユーザー平均回答時間',
      '全パーツ数',
      'ホームページ設置数',
      'お気に入り度',
      '利用中ユーザー数',
      '★評価平均'
    ]
    return {
      colTitleList : colTitleList,
      selectSitemapList: [],
      selectEmploymentList: [],
      sitemapListAll: [],
      employmentListAll: [],
      isLoading: true,
      scenarioNum: 0,
      isInitLoading: false,
      detailData: null,
      averageStar: 0,
      countAnswer: 0,
      questionnaireData: [],
      isQuestionnaireData: false,
      isQDLoading: true
    }
  },
  created () {
    this.init(this.chatbot)
  },
  methods: {
    init (chatbot) {
      this.isInitLoading = true
      this.$store.dispatch('chatbot/getChatBotDetail', chatbot.bot_id)
        .then((data) => {
          this.detailData = data
          this.isInitLoading = false
        })
      this.$store.dispatch('chatbot/getScenarioList', { companyid: this.chatbot.group, scenarioName: this.chatbot.scenario_name })
        .then((d) => {
          this.scenarioNum = d.data.length
        })
      // ★平均の取得
      this.$store.dispatch('chatbot/getChatBotStar', this.chatbot.bot_id)
        .then((data) => {
          this.averageStar = data.avg_star
          this.countAnswer = data.count_answer
          this.isLoading = false
          this.$emit('chatbotLoading')
        })
      // URLを挿入していく
      for (const root of this.sitemapRootList) {
        for (const sitemap of root.node_list) {
          for (const robo of sitemap.apply_robo_list.concat(sitemap.apply_minirobo_list)) {
            if (robo.data.bot_id === chatbot.bot_id) {
              this.selectSitemapList.push(sitemap)
            }
            this.sitemapListAll.push(sitemap)
          }
        }
      }
      // URLを挿入していく
      for (const employment of this.sitemapEmploymentList) {
        for (const robo of employment.apply_robo_list.concat(employment.apply_minirobo_list)) {
          if (robo.data.bot_id === chatbot.bot_id) {
            this.selectEmploymentList.push(employment)
          }
          this.employmentListAll.push(employment)
        }
      }
    },
    getRecordData (colName) {
      switch (colName) {
        case '作成日':
          return new Date(this.chatbot.created_at).toLocaleString()
        case 'ユーザー平均回答時間':
          return this.getAvgTime(this.chatbot)
        case '全パーツ数':
          return this.getAllPartsLength(this.chatbot)
        case 'ホームページ設置数':
          return this.getAllPages(this.chatbot)
        case 'お気に入り度':
          return this.getBookMarks(this.chatbot)
        case '利用中ユーザー数':
          return this.getUsedUsers(this.chatbot)
        case '★評価平均':
          return this.getAverageStar()
        default:
          return null
      }
    },
    // ユーザー平均回答時間
    getAvgTime () {
      if (this.detailData) {
        return this.detailData.avg + '秒'
      } else {
        '- 秒'
      }
    },
    // 全パーツ数
    getAllPartsLength () {
      return this.scenarioNum + '個'
    },
    // ホームページ設置数
    getAllPages () {
      return this.selectSitemapList.length + this.selectEmploymentList.length + 'ページ'
    },
    // お気に入り度
    getBookMarks (chatbot) {
      let cnt = 0
      for (const ucb of this.userChatBotBookMark) {
        if (ucb.chatbot === chatbot.bot_id) {
          cnt ++
        }
      }
      return cnt
    },
    // 利用中ユーザー数
    getUsedUsers () {
      if (this.detailData) {
        return this.detailData.num_user + '人'
      } else {
        '- 人'
      }
    },
    // ★評価平均
    getAverageStar () {
      if (this.averageStar === 0) {
        return '- （- 人）'
      } else {
        return this.averageStar + '（' + this.countAnswer + ' 人）'
      }
    },
    // 評価の詳細データ表示
    async dispQuestionnaireData () {
      await this.$store.dispatch('chatbot/getQuestionnaireData', this.chatbot.bot_id)
        .then((data) => {
          this.questionnaireData = data
          this.isQDLoading = false
          this.isQuestionnaireData = true
        })
    },
    // 評価の詳細データキャンセル
    cancelQuestionnaireData () {
      this.isQuestionnaireData = false
    }
  }
}
</script>

<style lang="scss" scoped>
.record {
  display: flex;
  width: 100%;
  .left-col {
    width: 200px;
  }
  .right-col {
    width: calc(100% - 200px);
    .button {
      background: #fffacd;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/ChatBotData.vue